import axios from "axios"

export default {
    async TaskToApproval(exitTaskId){
        const response = await axios.get(`/api/sgkexit/tasktoapproval/${exitTaskId}`)
        return response
    },
    async MyApprovals(data){
        const response = await axios.get('/api/sgkexit/myapprovals',data)
        return response
    },
    async Approve(exitTaskId){
        const response = await axios.get(`/api/sgkexit/approve/${exitTaskId}`)
        return response
    },
    async Reject(exitTaskId,desc){
        const response = await axios.get(`/api/sgkexit/reject/${exitTaskId}/${desc}`)
        return response
    },
    async GetTaskWithOTT(q){
        const response = await axios.get(`/api/sgkexit/gettaskwithott/${q}`)
        return response
    },
    async GetExitTaskInfo(employeeId) {
        return axios.get(`/api/hroperations/employee/sgk/exittaskinfo/${employeeId}`)
    },
    async ChangeApprovalStatusWithOTT(data) {
        return axios.post('/api/sgkexit/changeapprovalstatuswithott', data)
    },
}